var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-choice",class:{ hover:_vm.active }},_vm._l((_vm.selections),function(item,idx){return _c('button',{key:item.name,staticClass:"btn",class:{
      disabled: !_vm.active,
      default: _vm.active,
      error:  _vm.choiceIdx === idx&&item.isRight===0,
      correct: _vm.choiceIdx === idx&&item.isRight===1,
  },attrs:{"onselectstart":"return false;","oncontextmenu":"return false;"},on:{"click":function($event){return _vm.onChoice(item, idx)}}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }